import React from 'react';
import { TbBrandTeams } from 'react-icons/tb';

interface IconProps {
  color?: string;
  size?: number;
  width?: number;
  height?: number;
}

const TeamsIcon: React.FC<IconProps> = ({ color = '#6264A7', size, width = 28, height = 28 }) => {
  const w = size || width;
  const h = size || height;
  
  return <TbBrandTeams aria-hidden="true" color={color} width={w} height={h} strokeWidth={1.8} />;
};

export default TeamsIcon;
